<div class="copy_text_container" [@copyTextState]="state" (@copyTextState.done)="onCompleteAnimation()">
  <div class="title">{{title}}</div>
  <div class="copy_block">
    <p id="text_to_copy_element">{{textToCopy}}</p>
  </div>
  <close-button (close)="onCloseCopyText()" class="close_icon"></close-button>
</div>
<div class="overlay" (click)="onCloseCopyText()"></div>
